var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 1.99902C17.5253 1.99902 22.0031 6.47687 22.0031 12.0006C22.0031 17.5243 17.5253 22.0021 12.0016 22.0021C6.47785 22.0021 2 17.5243 2 12.0006C2 6.47687 6.47785 1.99902 12.0016 1.99902ZM12.0016 3.49902C7.30627 3.49902 3.5 7.3053 3.5 12.0006C3.5 16.6959 7.30627 20.5021 12.0016 20.5021C16.6968 20.5021 20.5031 16.6959 20.5031 12.0006C20.5031 7.3053 16.6968 3.49902 12.0016 3.49902ZM8.46329 14.7839C9.31243 15.8616 10.6034 16.5021 12.0015 16.5021C13.3978 16.5021 14.6872 15.8633 15.5365 14.7881C15.7932 14.463 16.2649 14.4076 16.5899 14.6644C16.915 14.9211 16.9704 15.3927 16.7136 15.7178C15.5829 17.1495 13.8617 18.0021 12.0015 18.0021C10.1389 18.0021 8.41567 17.1472 7.28507 15.7122C7.02872 15.3869 7.08466 14.9153 7.41002 14.6589C7.73537 14.4026 8.20694 14.4585 8.46329 14.7839ZM9.002 8.75121C9.69196 8.75121 10.2513 9.31054 10.2513 10.0005C10.2513 10.6905 9.69196 11.2498 9.002 11.2498C8.31204 11.2498 7.75271 10.6905 7.75271 10.0005C7.75271 9.31054 8.31204 8.75121 9.002 8.75121ZM15.002 8.75121C15.692 8.75121 16.2513 9.31054 16.2513 10.0005C16.2513 10.6905 15.692 11.2498 15.002 11.2498C14.312 11.2498 13.7527 10.6905 13.7527 10.0005C13.7527 9.31054 14.312 8.75121 15.002 8.75121Z",
    fill: "#2A3842"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEmoji);
export default __webpack_public_path__ + "static/media/btn-emoji.84dad84d033bcc26a8cf6dba5baf184f.svg";
export { ForwardRef as ReactComponent };